import "antd/lib/list/style";
import _List from "antd/lib/list";
import "antd/lib/avatar/style";
import _Avatar from "antd/lib/avatar";
import "antd/lib/empty/style";
import _Empty from "antd/lib/empty";
import "antd/lib/row/style";
import _Row from "antd/lib/row";
import "antd/lib/col/style";
import _Col from "antd/lib/col";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import _asyncToGenerator from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/runner/work/gtintel/gtintel/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { format, subMinutes } from 'date-fns';
import moment from 'moment';
import Router from 'next/router';
import { deleteAllNotifications } from '@gtintel/platform-api';
import { LoadingSpinner2 } from '@gtintel/platform-atoms';
import { DEFAULT_AVATAR, DEFAULT_NOTIFICATION_DATE_TIME_NOW } from '@gtintel/platform-constants';
import { FirebaseAppsEnum } from '@gtintel/platform-firebase';
import useNotifications from '../../../hooks/useNotifications';
import { Container, ListItemContainer } from './styles';
function removeDuplicates(array, property) {
  return array.filter(function (elem, index) {
    return array.findIndex(function (obj) {
      return obj[property] === elem[property];
    }) === index;
  });
}
var NotificationList = function NotificationList(_ref) {
  var user = _ref.user,
    userRole = _ref.userRole;
  var _useNotifications = useNotifications(user, FirebaseAppsEnum.GTIDev),
    devLoaded = _useNotifications.loaded,
    devNotifications = _useNotifications.notificationsPaginated,
    devRemoveNotification = _useNotifications.removeNotification,
    devUpdateStatus = _useNotifications.updateStatus,
    devLoadingPagination = _useNotifications.loadingPagination;
  var _useNotifications2 = useNotifications(user, FirebaseAppsEnum.GTIMessagingDev),
    messagingLoaded = _useNotifications2.loaded,
    messagingNotifications = _useNotifications2.notificationsPaginated,
    messagingRemoveNotification = _useNotifications2.removeNotification,
    messagingUpdateStatus = _useNotifications2.updateStatus,
    messagingLoadingPagination = _useNotifications2.loadingPagination;
  var listNotification = useMemo(function () {
    return !devLoaded || !messagingLoaded ? [] : [].concat(_toConsumableArray(devNotifications.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        removeNotification: devRemoveNotification,
        updateStatus: devUpdateStatus
      });
    })), _toConsumableArray(messagingNotifications.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        removeNotification: messagingRemoveNotification,
        updateStatus: messagingUpdateStatus
      });
    })));
  }, [devLoaded, messagingLoaded, devNotifications, messagingNotifications, devRemoveNotification, devUpdateStatus, messagingRemoveNotification, messagingUpdateStatus]);
  var redirectTo = useCallback(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(notification) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return notification.updateStatus(notification.notification_id);
            case 2:
              if (notification.project_id) {
                Router.push("/".concat(userRole, "/project/detail/").concat(notification.project_id));
              } else {
                Router.push({
                  pathname: "/".concat(userRole, "/message")
                });
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [userRole]);
  var sortedNotifications = useMemo(function () {
    return removeDuplicates(listNotification.sort(function (firstNotification, secondNotification) {
      var _firstNotification$cr, _secondNotification$c;
      return moment((_firstNotification$cr = firstNotification.created_at) !== null && _firstNotification$cr !== void 0 ? _firstNotification$cr : firstNotification.update_date).isAfter((_secondNotification$c = secondNotification.created_at) !== null && _secondNotification$c !== void 0 ? _secondNotification$c : secondNotification.update_date) ? -1 : 1;
    }), 'notification_id');
  }, [listNotification]);
  var _useState = useState(sortedNotifications),
    notificationList = _useState[0],
    setNotificationList = _useState[1];
  var _useState2 = useState(false),
    isDeleted = _useState2[0],
    setIsDeleted = _useState2[1];
  useEffect(function () {
    if (notificationList.length > 0 && isDeleted) return setNotificationList([]);
    if (!isDeleted && notificationList.length !== listNotification.length) {
      return setNotificationList(sortedNotifications);
    }
  }, [sortedNotifications, isDeleted]);
  function removeAllNotifications(user_id) {
    deleteAllNotifications(user_id).then(function () {
      setIsDeleted(true);
    });
  }
  return __jsx(Container, {
    "data-testid": "notification-list"
  }, !devLoaded || !messagingLoaded ? __jsx(LoadingSpinner2, {
    margin: 200
  }) : __jsx("div", null, __jsx(_Row, {
    gutter: [0, 20]
  }, __jsx(_Col, {
    span: 12
  }, __jsx(_Button, {
    type: "primary",
    onClick: function onClick() {
      return removeAllNotifications(user.id);
    },
    style: {
      alignItems: 'flex-start',
      marginBottom: 10
    }
  }, "Remove All Notifications"))), __jsx(_List, {
    loading: devLoadingPagination || messagingLoadingPagination,
    locale: {
      emptyText: __jsx(_Empty, {
        description: "Nothing here yet",
        image: _Empty.PRESENTED_IMAGE_SIMPLE
      })
    },
    dataSource: notificationList,
    renderItem: function renderItem(item) {
      var _item$senderName;
      var date;
      if (item.created_at) {
        date = new Date(item.created_at);
      } else if (item.update_date) {
        date = new Date(item.update_date);
      } else {
        date = new Date();
      }
      var calendar = {
        lastDay: '[Yesterday at] HH:mm',
        sameDay: '[Today at] HH:mm',
        nextDay: '[Tomorrow at] HH:mm',
        lastWeek: '[last] dddd [at] HH:mm',
        nextWeek: 'dddd [at] HH:mm',
        sameElse: 'L'
      };
      var dateStr = format(subMinutes(date, date.getTimezoneOffset()), DEFAULT_NOTIFICATION_DATE_TIME_NOW);
      return __jsx(ListItemContainer, {
        background: item.color
      }, __jsx(_List.Item, null, __jsx("div", {
        className: "ant-list-item-meta",
        onClick: function onClick() {
          return redirectTo(item);
        }
      }, __jsx(_List.Item.Meta, {
        style: {
          cursor: 'pointer'
        },
        avatar: __jsx(_Avatar, {
          src: item.anonymous || item.senderName === 'Anonymous Client' ? DEFAULT_AVATAR : item.senderAvatar || DEFAULT_AVATAR
        }),
        title: __jsx("p", null, __jsx("span", {
          className: "txt-bold"
        }, (_item$senderName = item.senderName) !== null && _item$senderName !== void 0 ? _item$senderName : item.sender_name), ' - ', item.content ? __jsx("span", {
          dangerouslySetInnerHTML: {
            __html: item.content
          }
        }) : "send a message in ".concat(item.project_name), ' ')
      })), __jsx("div", null, moment(dateStr).calendar(calendar)), __jsx("div", {
        className: "icon",
        onClick: function onClick() {
          return item.removeNotification(item.notification_id);
        }
      }, __jsx(FontAwesomeIcon, {
        style: {
          cursor: 'pointer'
        },
        icon: faTrashAlt
      }))));
    }
  })));
};
export default NotificationList;